import {useEffect, useRef, useCallback} from 'react'

const useControlledFetch = () => {
  const controllerRef = useRef<any>(null)
  const fetchControllerRef = useRef<any>()
  const isMountedRef = useRef(true)

  useEffect(() => {
    fetchControllerRef.current = {
      startFetch: async (dispatch: any, fetch: any, filter: any) => {
        try {
          if (controllerRef.current) {
            controllerRef.current.abort()
          }
          const controller = new AbortController()
          await dispatch(fetch({filter, signal: controller.signal}))
          controllerRef.current = controller
        } catch (error: any) {
          if (error.name === 'AbortError') {
            console.log('Fetch aborted')
          }
        }
      },

      controller: () => {
        if (controllerRef.current) {
          controllerRef.current.abort()
        }
        const controller = new AbortController()
        controllerRef.current = controller
        return controller.signal
      },

      abortFetch: () => {
        if (controllerRef.current) {
          controllerRef.current.abort()
        }
      },
    }

    return () => {
      isMountedRef.current = false
      if (controllerRef.current) {
        controllerRef.current.abort()
      }
    }
  }, [])

  const startFetch = useCallback(async (dispatch: any, fetch: any, filter: any) => {
    if (!isMountedRef.current) {
      return
    }
    await fetchControllerRef.current.startFetch(dispatch, fetch, filter)
  }, [])

  const controller = useCallback(() => {
    if (!isMountedRef.current) {
      return
    }
    return fetchControllerRef.current.controller()
  }, [])

  const abortFetch = useCallback(() => {
    if (!isMountedRef.current) {
      return
    }
    fetchControllerRef.current.abortFetch()
  }, [])

  return {startFetch, controller, abortFetch}
}

export default useControlledFetch
